/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Verify_ConfirmInputs */

const en_onboarding_verify_confirm = /** @type {(inputs: Onboarding_Verify_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify Code`)
};

const de_onboarding_verify_confirm = /** @type {(inputs: Onboarding_Verify_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code bestätigen`)
};

const fr_onboarding_verify_confirm = /** @type {(inputs: Onboarding_Verify_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifier le code`)
};

const es_onboarding_verify_confirm = /** @type {(inputs: Onboarding_Verify_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificar código`)
};

const it_onboarding_verify_confirm = /** @type {(inputs: Onboarding_Verify_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica Codice`)
};

const nl_onboarding_verify_confirm = /** @type {(inputs: Onboarding_Verify_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifieer code`)
};

const pl_onboarding_verify_confirm = /** @type {(inputs: Onboarding_Verify_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potwierdź kod`)
};

const fi_onboarding_verify_confirm = /** @type {(inputs: Onboarding_Verify_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vahvista Koodi`)
};

const da_onboarding_verify_confirm = /** @type {(inputs: Onboarding_Verify_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekræft kode`)
};

const sv_onboarding_verify_confirm = /** @type {(inputs: Onboarding_Verify_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifiera kod`)
};

/**
* | output |
* | --- |
* | "Verify Code" |
*
* @param {Onboarding_Verify_ConfirmInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_verify_confirm = /** @type {((inputs?: Onboarding_Verify_ConfirmInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Verify_ConfirmInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_verify_confirm(inputs)
	if (locale === "fr") return fr_onboarding_verify_confirm(inputs)
	if (locale === "es") return es_onboarding_verify_confirm(inputs)
	if (locale === "it") return it_onboarding_verify_confirm(inputs)
	if (locale === "nl") return nl_onboarding_verify_confirm(inputs)
	if (locale === "pl") return pl_onboarding_verify_confirm(inputs)
	if (locale === "fi") return fi_onboarding_verify_confirm(inputs)
	if (locale === "da") return da_onboarding_verify_confirm(inputs)
	if (locale === "sv") return sv_onboarding_verify_confirm(inputs)
	return en_onboarding_verify_confirm(inputs)
});